import { Event } from './Event';

/**
 * Keyboard event class for handling keyboard input
 */
export class KeyboardEvent extends Event {
  private readonly key: string;
  private readonly code: string;
  private readonly ctrlKey: boolean;
  private readonly shiftKey: boolean;
  private readonly altKey: boolean;

  constructor(
    type: string,
    key: string,
    code: string,
    ctrlKey: boolean = false,
    shiftKey: boolean = false,
    altKey: boolean = false
  ) {
    super(type);
    this.key = key;
    this.code = code;
    this.ctrlKey = ctrlKey;
    this.shiftKey = shiftKey;
    this.altKey = altKey;
  }

  /**
   * Get the key that was pressed
   */
  public getKey(): string {
    return this.key;
  }

  /**
   * Get the key code
   */
  public getCode(): string {
    return this.code;
  }

  /**
   * Check if the control key was pressed
   */
  public isCtrlKey(): boolean {
    return this.ctrlKey;
  }

  /**
   * Check if the shift key was pressed
   */
  public isShiftKey(): boolean {
    return this.shiftKey;
  }

  /**
   * Check if the alt key was pressed
   */
  public isAltKey(): boolean {
    return this.altKey;
  }
}
